import { sendPv } from './logTrack'

export default class Exposure {
  constructor(root = null) {
    this.init(root)
  }

  init(root) {
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(item => {
          if (item.intersectionRatio === 1) {
            let data = item.target.getAttribute('data-upload')
            if (!data) return
            data = typeof data === 'string' ? JSON.parse(data) : data
            this.upload(data)
            this.observer && this.observer.unobserve(item.target)
          }
        })
      },
      {
        root,
        rootMargin: '0px',
        threshold: 1
      }
    )
  }

  add(el) {
    this.observer && this.observer.observe(el)
  }

  upload(data) {
    sendPv(data)
  }
}
